import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map, pathOr } from 'ramda';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { Query } from 'react-apollo';
import { TEAM_LIST } from './queries';
import PaginatedSearch from '../PaginatedSearch';
import { debounce } from '../../utils';

const RECORDS_PER_PAGE = 5;

const styles = () => ({});

class TeamsTableProvider extends Component {
  state = {
    searchTxt: '',
    filter: '',
    currentPage: 1,
    skip: 0,
  };

  onChangeInput = (e) => {
    this.setState({ searchTxt: e.target.value }, () => {
      debounce(() => {
        this.setState(prevState => ({
          filter: prevState.searchTxt,
        }));
      }, 500)();
    });
  };

  renderTeamsTable = (teams, match) => (
    <React.Fragment>
      <TableHead>
        <TableRow>
          <TableCell>Team</TableCell>
          <TableCell>Id</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {map(
          ({ team_id: teamId, display_name: displayName }) => (
            <TableRow key={teamId}>
              <TableCell>
                <Link
                  to={`${match.url}/${teamId}`}
                  className={{
                    color: '#1682bc',
                  }}
                >
                  {displayName}
                </Link>
              </TableCell>
              <TableCell>{teamId}</TableCell>
            </TableRow>
          ),
          teams,
        )}
      </TableBody>
    </React.Fragment>
  );

  onClickPage = (page) => {
    const newSkip = RECORDS_PER_PAGE * (page - 1);
    this.setState({
      currentPage: page,
      skip: newSkip,
    });
  };

  render() {
    const {
      searchTxt, filter, currentPage, skip 
    } = this.state;

    const { match } = this.props;

    return (
      <Query
        query={TEAM_LIST}
        variables={{ tfilter: filter, skip, limit: RECORDS_PER_PAGE }}
        fetchPolicy="network-only"
        notifyOnNetworkStatusChange
      >
        {({ data, loading, error }) => {
          if (error) return 'ERROR';
          return (
            <React.Fragment>
              <PaginatedSearch
                searchTxt={searchTxt}
                onChangeInput={this.onChangeInput}
                renderEndpoints={this.renderTeamsTable}
                formPlaceholder="Search Teams Here"
                currentPage={currentPage}
                thresholdPageBtns={5}
                onClickPage={this.onClickPage}
                recordsPerPage={RECORDS_PER_PAGE}
                totalRecords={pathOr(0, ['teamList', 'count'], data)}
                data={pathOr([], ['teamList', 'teamList'], data)}
                isLoading={loading}
                {...this.props}
              />
              <Link to={`${match.url}/new`} style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  color="primary"
                  aria-label="New"
                  styles={{
                    marginTop: '1em',
                  }}
                >
                  New Team
                </Button>
              </Link>
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

TeamsTableProvider.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(TeamsTableProvider);
